import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import s from './Ticker.scss';

const Ticker = ({ content, attrs = {}, setup }) => {
	if (!content) return null;
	const styles = {};
	if (attrs.textColor) styles.color = attrs.textColor;

	let innerTextContent = translate(setup, content.ticker);
	let innerTextLength = Math.round(innerTextContent.length / 40);
	if (innerTextLength === 0) innerTextLength = 1;
	innerTextContent = `<span>${innerTextContent}</span>`;

	const classes = [s.ticker];
	classes.push(s[`ticker__${innerTextLength}`]);

	innerTextContent = `<div>${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}</div>`;

	return (
		<div className={classes.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(innerTextContent, { ADD_ATTR: ['target'] }) }} style={styles} />
	);
};

export default hot(module)(Ticker);
